export const chartTheme = {
  background: 'transparent',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: 12,
  textColor: '#1E293B',
  axis: {
    domain: {
      line: {
        stroke: '#CBD5E1',
        strokeWidth: 1
      }
    },
    legend: {
      text: {
        fontSize: 13,
        fontWeight: 600,
        fill: '#1E293B'
      }
    },
    ticks: {
      line: {
        stroke: '#CBD5E1',
        strokeWidth: 1
      },
      text: {
        fontSize: 12,
        fill: '#334155',
        fontWeight: 500
      }
    }
  },
  grid: {
    line: {
      stroke: '#E2E8F0',
      strokeWidth: 1,
      strokeDasharray: '4 4'
    }
  },
  legends: {
    title: {
      text: {
        fontSize: 13,
        fontWeight: 600,
        fill: '#1E293B'
      }
    },
    text: {
      fontSize: 12,
      fontWeight: 500,
      fill: '#334155'
    },
    ticks: {
      line: {
        stroke: '#64748B',
        strokeWidth: 1
      },
      text: {
        fontSize: 11,
        fill: '#334155'
      }
    },
    itemsSpacing: 14,
    itemWidth: 100,
    itemHeight: 22,
    itemDirection: 'left-to-right',
    symbolSize: 14,
    symbolShape: 'circle'
  },
  tooltip: {
    container: {
      background: '#FFFFFF',
      color: '#1E293B',
      fontSize: '14px',
      fontWeight: 500,
      borderRadius: '6px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      padding: '14px 18px',
    }
  },
  labels: {
    text: {
      fontSize: 12,
      fontWeight: 600,
      fill: '#1E293B'
    }
  },
  dots: {
    text: {
      fontSize: 12,
      fontWeight: 600,
      fill: '#1E293B'
    }
  },
  annotations: {
    text: {
      fontSize: 13,
      fill: '#1E293B',
      outlineWidth: 2,
      outlineColor: '#ffffff',
      outlineOpacity: 1
    },
    link: {
      stroke: '#1E293B',
      strokeWidth: 1.5,
      outlineWidth: 2,
      outlineColor: '#ffffff',
      outlineOpacity: 1
    },
    outline: {
      stroke: '#1E293B',
      strokeWidth: 2,
      outlineWidth: 2,
      outlineColor: '#ffffff',
      outlineOpacity: 1
    },
    symbol: {
      fill: '#1E293B',
      outlineWidth: 2,
      outlineColor: '#ffffff',
      outlineOpacity: 1
    }
  }
};

export const colors = [
  '#003087', // primary blue
  '#0066CC', // lighter blue
  '#36A2EB', // bright blue
  '#4BC0C0', // teal
  '#9966FF', // purple
  '#FF9F40', // orange
  '#4D5382', // indigo
  '#1976D2', // material blue
  '#673AB7', // deep purple
  '#26A69A', // teal
  '#7E57C2', // medium purple
  '#5C6BC0', // indigo blue
  '#FFB81C', // yellow
  '#00897b', // medium teal
  '#3949AB', // indigo
];

export const getGradient = (color: string) => [
  { offset: 0, color: color, opacity: 0.9 },
  { offset: 100, color: color, opacity: 0.3 },
]; 